import { select } from 'redux-saga/effects';
import { createSelector } from 'reselect';
import '../../../actions.js';
import { NEW_PRESCRIPTION, NEW_PRESCRIPTION_AND_UPLOAD } from '../../../constants.js';
import '../../../add-to-cart/selectors.js';
import '../../../bundles/selectors.js';
import '../../../bundles/reducer.js';
import { getIsPrescriptionFormStepValid, getPrescriptionType } from '../../selectors.js';
import '../../reducer.js';
import '../../../products/selectors.js';
import '../../../products/reducer.js';
import { PrescriptionFormStepContainer } from '../../../../steps/PrescriptionFormStep/PrescriptionFormStepContainer.js';

const prescriptionFormStepBase = {
    *onNext () {
        const isValid = yield select(getIsPrescriptionFormStepValid);
        if (!isValid) {
            return new Error(`Need valid prescription data for unknown customer`);
        }
    },
    view: PrescriptionFormStepContainer,
    stepStatus: createSelector(getPrescriptionType, (prescriptionType)=>prescriptionType === NEW_PRESCRIPTION || prescriptionType === NEW_PRESCRIPTION_AND_UPLOAD ? 'sub-step' : 'hidden'
    )
};

export { prescriptionFormStepBase };
//# sourceMappingURL=prescription-form.js.map
